type SelectedFeedFormTabCtx = (prevTabSelector: string | null) => void;

export const SelectedFeedFormTabCtx = {
  prevTabSelector: null as string | null,
  subscribers: [] as SelectedFeedFormTabCtx[],
  isFormFieldShake: false as boolean,

  // Add a subscriber
  subscribe(callback: SelectedFeedFormTabCtx) {
    this.subscribers.push(callback);
    // Return an unsubscribe function
    return () => {
      this.unsubscribe(callback);
    };
  },

  // Remove a subscriber
  unsubscribe(callback: SelectedFeedFormTabCtx) {
    this.subscribers = this.subscribers.filter(sub => sub !== callback);
  },

  // Notify all subscribers
  notifySubscribers() {
    this.subscribers.forEach(callback => callback(this.prevTabSelector));
  },

  // Set the selected tab and notify subscribers
  setTabs(prevTabSelector: string | null) {
    this.prevTabSelector = prevTabSelector;
    this.notifySubscribers();
  },

  // Clear the selected tab and notify subscribers
  clearSelecteTab() {
    this.prevTabSelector = null;
    this.notifySubscribers();
  }
};
